import { render, staticRenderFns } from "./liveAssistant.vue?vue&type=template&id=47e0c32a&scoped=true"
import script from "./liveAssistant.vue?vue&type=script&lang=js"
export * from "./liveAssistant.vue?vue&type=script&lang=js"
import style0 from "./liveAssistant.vue?vue&type=style&index=0&id=47e0c32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e0c32a",
  null
  
)

export default component.exports